module.exports = __webpack_public_path__ + "static/media/white-thumb-up.3bff0f87.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Kendra/images/white-thumb-up.svg
// module id = 3232
// module chunks = 0